const M = [
  {
    name: "noOpening",
    zh: "不在营业时间内",
    en: "No opening"
  },
  {
    name: "shoppingCart",
    zh: "购物车",
    en: "Shopping cart"
  },
  {
    name: "gong",
    zh: "共",
    en: "Total"
  },
  {
    name: "items",
    zh: "件商品",
    en: "items"
  },
  {
    name: "unpurchasedGoods",
    zh: "未选购商品",
    en: "Unpurchased goods"
  },
  {
    name: "additionalDeliveryFee",
    zh: "另需配送费",
    en: "Additional for delivery fee"
  },
  {
    name: "stillNeed",
    zh: "差",
    en: "Still need"
  },
  {
    name: "toSettlement",
    zh: "去结算",
    en: "To settlement"
  },
  {
    name: "clearCart",
    zh: "清空购物车",
    en: "Clear cart"
  },
  {
    name: "sureClearCart",
    zh: "确定清空购物车？",
    en: "Are you sure to clear your cart?"
  }
];

export default M;
